import { useCallback, useEffect } from "react";

/**
 * Warns before losing unsaved edits. The shell mounts this module under a
 * plain `<BrowserRouter>` (no data router), so `useBlocker` is unavailable:
 * a tab close / reload goes through `beforeunload`, and the page's own
 * navigation buttons go through `confirmLeave`.
 */
export const useUnsavedChangesPrompt = (dirty: boolean, message: string) => {
  useEffect(() => {
    if (!dirty) return;
    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty, message]);

  return useCallback(() => !dirty || window.confirm(message), [dirty, message]);
};
